// Handle login form
(function() {
  const loginForm = document.getElementById("customer_login");
  if (!loginForm) return;

  const elements = {
    submitBtn: document.getElementById("LoginForm-SubmitBtn"),
    emailError: document.getElementById("LoginForm-Email-error"),
    passwordError: document.getElementById("LoginForm-Password-error"),
    commonError: document.getElementById("LoginForm-Error"),
    emailField: document.getElementById("LoginForm-Email"),
    passwordField: document.getElementById("LoginForm-Password"),
  };

  const savedEmail = sessionStorage.getItem("email");
  if (savedEmail && elements.emailField) {
    elements.emailField.value = savedEmail;
  }

  const handleFieldError = (field, hasError) => {
    field.classList.toggle("d-none", !hasError);
  };

  const handleCommonError = () => {
    elements.submitBtn.classList.add("error");
    elements.commonError.classList.remove("d-none");
  };

  elements.submitBtn.addEventListener("click", () => {
    const emailEmpty = !elements.emailField?.value?.trim();
    const passwordEmpty = !elements.passwordField?.value?.trim();

    if (emailEmpty || passwordEmpty) {
      handleFieldError(elements.emailError, emailEmpty);
      handleFieldError(elements.passwordError, passwordEmpty);
      elements.commonError.innerText = "Please fill in the required fields";
      handleCommonError();
    } else {
      sessionStorage.setItem("email", elements.emailField?.value?.trim());
      loginForm.submit();
    }
  });
})();

// Handle register form
(function() {
  const registerForm = document.getElementById("create_customer");
  if (!registerForm) return;

  const elements = {
    submitBtn: document.getElementById("RegisterForm-SubmitBtn"),
    commonError: document.getElementById("RegisterForm-Error"),
    fields: {
      firstName: document.getElementById("RegisterForm-FirstName"),
      lastName: document.getElementById("RegisterForm-LastName"),
      email: document.getElementById("RegisterForm-Email"),
      password: document.getElementById("RegisterForm-Password"),
    },
    errors: {
      firstName: document.getElementById("RegisterForm-FirstName-error"),
      lastName: document.getElementById("RegisterForm-LastName-error"),
      email: document.getElementById("RegisterForm-Email-error"),
      password: document.getElementById("RegisterForm-Password-error"),
    },
  };

  const handleFieldError = (field, hasError) => {
    field.classList.toggle("d-none", !hasError);
  };

  const handleCommonError = (message) => {
    elements.submitBtn.classList.add("error");
    elements.commonError.innerText = message;
    elements.commonError.classList.remove("d-none");
  };

  const validateEmailField = (emailField) => {
    const emailValue = emailField.value.trim();
    const isValidEmail = validateEmail(emailValue);
    handleFieldError(elements.errors.email, !isValidEmail);
    return isValidEmail;
  };

  elements.submitBtn.addEventListener("click", () => {
    const fieldsEmpty = Object.entries(elements.fields).reduce((acc, [key, field]) => {
      const empty = !field?.value?.trim();
      handleFieldError(elements.errors[key], empty);
      return acc || empty;
    }, false);

    const isEmailValid = validateEmailField(elements.fields.email);
    const isPasswordValid = elements.fields.password.value;

    if (fieldsEmpty) {
      handleCommonError("Please fill in the required fields");
    } else if (!isEmailValid) {
      handleCommonError("Invalid email format");
     } else if (isPasswordValid.length < 5) {
      handleCommonError("Password minimum 5 characters");
    } else {
      registerForm.submit();
    }
  });
})();

// Handle reset password form
(function() {
  const resetPasswordForm = document.getElementById("reset_customer_password");
  if (!resetPasswordForm) return;

  const elements = {
    submitBtn: document.getElementById("ResetForm-SubmitBtn"),
    commonError: document.getElementById("ResetForm-Error"),
    fields: {
      password: document.getElementById("ResetForm-Password"),
      confirmPassword: document.getElementById("ResetForm-Password-Confirmation"),
    },
    errors: {
      password: document.getElementById("ResetForm-Password-error"),
      confirmPassword: document.getElementById("ResetForm-Password-Confirmation-error"),
    },
  };

  const handleFieldError = (field, hasError) => {
    field.classList.toggle("d-none", !hasError);
  };

  const handleCommonError = (message) => {
    elements.submitBtn.classList.add("error");
    elements.commonError.innerText = message;
    elements.commonError.classList.remove("d-none");
  };

  elements.submitBtn.addEventListener("click", () => {
    const password = elements.fields.password?.value;
    const confirmPassword = elements.fields.confirmPassword?.value;

    if (!password || !confirmPassword) {
      handleCommonError("Please fill in the required fields");
      handleFieldError(elements.errors.password, !password);
      handleFieldError(elements.errors.confirmPassword, !confirmPassword);
    } else if (password !== confirmPassword) {
      handleFieldError(elements.errors.password, true);
      handleFieldError(elements.errors.confirmPassword, true);
      handleCommonError("Password and confirmation password must match");
    } else {
      resetPasswordForm.submit();
    }
  });
})();
